const textDefaults = {
	EN: {
		welcomeTitle: 'Identity check',
		welcomeReason: 'Please take a selfie so we can confirm it is really you.',
		getStarted: 'Start',
		verified: 'Identity verified',
		tryAgainTitle: 'That did not match',
		tryAgainBody: 'Please try again.',
		tryAgain: 'Try again',
		attemptCounter: 'Attempt {current} of {max}',
		noReference: 'No reference selfie was uploaded during pre-registration. Please go to a security guard.',
		mismatchFinal: 'We could not verify your identity. Please go to a security guard.',
		finish: 'Finish',
	},
	NL: {
		welcomeTitle: 'Identiteitscontrole',
		welcomeReason: 'Neem een selfie zodat we kunnen bevestigen dat u het echt bent.',
		getStarted: 'Start',
		verified: 'Identiteit geverifieerd',
		tryAgainTitle: 'Dat kwam niet overeen',
		tryAgainBody: 'Probeer het opnieuw.',
		tryAgain: 'Opnieuw proberen',
		attemptCounter: 'Poging {current} van {max}',
		noReference: 'Er werd geen referentieselfie geüpload tijdens de preregistratie. Ga naar een bewaker.',
		mismatchFinal: 'We konden uw identiteit niet verifiëren. Ga naar een bewaker.',
		finish: 'Voltooien',
	},
	FR: {
		welcomeTitle: "Vérification d'identité",
		welcomeReason: 'Veuillez prendre un selfie afin que nous puissions confirmer qu’il s’agit bien de vous.',
		getStarted: 'Commencer',
		verified: 'Identité vérifiée',
		tryAgainTitle: 'Cela ne correspond pas',
		tryAgainBody: 'Veuillez réessayer.',
		tryAgain: 'Réessayer',
		attemptCounter: 'Tentative {current} sur {max}',
		noReference:
			'Aucun selfie de référence n’a été téléchargé lors de la préinscription. Veuillez vous adresser à un agent de sécurité.',
		mismatchFinal: "Nous n’avons pas pu vérifier votre identité. Veuillez vous adresser à un agent de sécurité.",
		finish: 'Terminer',
	},
	DE: {
		welcomeTitle: 'Identitätsprüfung',
		welcomeReason: 'Bitte machen Sie ein Selfie, damit wir bestätigen können, dass Sie es wirklich sind.',
		getStarted: 'Starten',
		verified: 'Identität bestätigt',
		tryAgainTitle: 'Das stimmte nicht überein',
		tryAgainBody: 'Bitte versuchen Sie es erneut.',
		tryAgain: 'Erneut versuchen',
		attemptCounter: 'Versuch {current} von {max}',
		noReference:
			'Bei der Vorregistrierung wurde kein Referenz-Selfie hochgeladen. Bitte wenden Sie sich an einen Sicherheitsmitarbeiter.',
		mismatchFinal:
			'Wir konnten Ihre Identität nicht bestätigen. Bitte wenden Sie sich an einen Sicherheitsmitarbeiter.',
		finish: 'Fertig',
	},
};

export function getTextDefaults(lang) {
	return textDefaults[String(lang || 'EN').toUpperCase()] || textDefaults['EN'];
}

export function getLanguages() {
	return Object.keys(textDefaults);
}
